import memoize from 'fast-memoize'
import { RequestType } from 'src/services/oms'

const mirror = (obj) => obj
export const memMirror = memoize(mirror)

export const createCancellableCallback = (fn) => {
  let isCancelled = false
  const _fn = (...args) => {
    if (!isCancelled) fn(...args)
  }
  _fn.cancel = (...args) => {
    isCancelled = true
  }
  return _fn
}

export const retrieveCookies = (req: RequestType): string =>
  typeof window !== 'undefined' ? document.cookie : req && req.get ? req.get('Cookie') || req?.headers?.cookie : ''

export { memoize }
